import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Line } from '@/@bothrs-ui/web/components/primitives/line/Line'
import { AgendaDetail } from './AgendaDetail'

type AgendaNotesProps = {
  /** Heads the notes, e.g. "Over deze afspraak". */
  title?: string
  /** The hospital's free text, as HTML. */
  notes: string[]
}

/** The hospital's free text about an agenda item, under a divider. Renders nothing without notes. */
const AgendaNotes = ({ title, notes }: AgendaNotesProps) => {
  const theme = useTheme()

  if (notes.length === 0) {
    return null
  }

  return (
    <>
      <Line />
      <FlexColumn gap={theme.UI.Spacing.Space4}>
        {title ? <AgendaDetail.SectionTitle>{title}</AgendaDetail.SectionTitle> : null}
        {notes.map((note, index) => (
          // The notes have no id and never reorder, so their position is a stable key.
          // biome-ignore lint/suspicious/noArrayIndexKey: see above
          <AgendaDetail.Notes key={index} html={note} />
        ))}
      </FlexColumn>
    </>
  )
}

export { AgendaNotes }
